import { AnimationDefinition } from "framer-motion";
import { createContext, useState } from "react";

export type AnimationState = "unmounted" | "hidden" | "visible";

export const ModalContext = createContext<{
  animation: AnimationState;
  onComplete?: (animation: AnimationDefinition) => void;
  isOpen?: boolean;
}>({
  animation: "unmounted",
  onComplete: undefined,
  isOpen: undefined,
});

export function useModalLayout() {
  const [layoutId, setLayoutId] = useState<string | number>();
  const close = () => setLayoutId(undefined);

  const dialogProps = {
    layoutId,
    close,
  };

  return { close, dialogProps, setLayoutId, layoutId };
}
